<template>
  <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.50216 10.8334L5.09683 7.50008M5.09683 7.50008L8.50216 4.16675M5.09683 7.50008H14.4615C15.3646 7.50008 16.2308 7.85127 16.8694 8.47639C17.508 9.10151 17.8668 9.94936 17.8668 10.8334C17.8668 11.7175 17.508 12.5653 16.8694 13.1904C16.2308 13.8156 15.3646 14.1667 14.4615 14.1667H13.6101"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
